import React from "react";
// import VendorConfigContainer from "../containers/VendorDetails/ConfigDetail/VendorConfigContainer";
import VendorRequestContainer from "containers/VendorDetails/RequestDetail";

const VendorRequest = () => {
  return (
    <>
      <VendorRequestContainer />
    </>
  );
};

export default VendorRequest;